import {
    Box,
    Button,
    omitThemingProps,
    Text,
    useMultiStyleConfig,
    Flex,
    Popover,
    PopoverTrigger,
    PopoverContent,
    PopoverArrow,
    PopoverCloseButton,
    PopoverBody,
    Portal,
    IconButton
} from '@chakra-ui/react'
import PropTypes from 'prop-types'
import React from 'react'
import {InfoIconFilled} from '../icons'

const Chip = (props) => {
    const styles = useMultiStyleConfig('Chip', props)
    const {name, image, count, orderable, selected, value, href, onChange, ...linkProps} =
        omitThemingProps(props)

    return (
        <Flex alignItems="flex-start" {...styles.flexContainer}>
            <Button
                // if count is given and not 0 -> shows the count in brackets
                aria-label={name + (!!count && count !== 0 ? ' (' + count + ')' : '')}
                onClick={(e) => {
                    e.preventDefault()
                    onChange(value, href, e)
                }}
                variant="unstyled"
                {...styles.container}
                {...linkProps}
            >
                {image && (
                    <Box
                        {...styles.image}
                        backgroundRepeat="no-repeat"
                        backgroundSize="cover"
                        backgroundImage={
                            image ? `url("${encodeURI(image.disBaseLink || image.link)}")` : ''
                        }
                    />
                )}
                {name && <Text {...styles.label}>{name}</Text>}
                {count && count !== 0 && (
                    <Text as="span" {...styles.count}>
                        {count}
                    </Text>
                )}
            </Button>
            {props.tooltip && selected && (
                <Popover
                    placement="top"
                    preventOverflow={true}
                    variant="chipTooltip"
                    arrowSize={12}
                    arrowShadowColor="none"
                    closeOnEsc={true}
                    gutter={34}
                >
                    <PopoverTrigger>
                        <IconButton
                            minWidth="unset"
                            height="unset"
                            minHeight="unset"
                            lineHeight={0}
                            marginLeft={1}
                            icon={<InfoIconFilled boxSize={3} color="stokkeCore.black" />}
                            variant="unstyled"
                        />
                    </PopoverTrigger>
                    {/* By default the Popover component is not rendered in portal */}
                    <Portal>
                        {/*
                            Popover component does not respect passed z-index props.
                            For this reason is used additional Box component.
                        */}
                        <Box zIndex="1301" w="full" h="full" position="relative">
                            <PopoverContent>
                                <PopoverArrow />
                                <PopoverCloseButton />
                                <PopoverBody>
                                    <Box dangerouslySetInnerHTML={{__html: props.tooltip}} />
                                </PopoverBody>
                            </PopoverContent>
                        </Box>
                    </Portal>
                </Popover>
            )}
        </Flex>
    )
}

Chip.propTypes = {
    /**
     * Indicates whether the option is disabled
     */
    disabled: PropTypes.bool,
    /**
     * Indicates whether the option is selected.
     * This props is provided internally by SwatchGroup
     */
    selected: PropTypes.bool,
    /**
     *  The url of this option
     */
    href: PropTypes.string,
    /**
     * This function is called whenever the user selects an option.
     * It is passed the new value.
     */
    onChange: PropTypes.func,
    /**
     * The value for the option.
     */
    value: PropTypes.string,
    /**
     * The display value for each swatch
     */
    name: PropTypes.string,
    /**
     * The image url for this option
     */
    image: PropTypes.object,
    count: PropTypes.number,
    tooltip: PropTypes.string
}

export default Chip
